import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App.tsx';
import { LabOSAuth } from './lib/labos.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LabOSAuth appId="podcast-news-analysis">
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </LabOSAuth>
  </StrictMode>,
);
